module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-container"
  }, [_c('div', {
    staticClass: "progress-circular",
    style: (_vm.circularStyle)
  }, [_c('span', {
    staticClass: "circle-center",
    style: ({
      background: _vm.backgroundColor
    })
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62b25ff4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/circularProgress/circularProgress.vue.html
// module id = 99Jf
// module chunks = 2